import {IChapterCue} from '@utils/parseChapterMarks';

export const sanitizeChapters = (
    cues: IChapterCue[],
    duration: number,
): IChapterCue[] => {
    const sanitizedCues = cues
        .filter(cue => cue.startTime < duration)
        .map((cue, i) => ({
            ...cue,
            startTime: Math.min(cue.startTime, duration),
            endTime:
                i === cues.length - 1
                    ? duration
                    : Math.min(cue.endTime, duration),
        }))
        .filter(cue => cue.endTime > cue.startTime);

    return sanitizedCues;
};
